import React from 'react'
import "../nailcss/NailartLocationSection.css";

const LOCATIONS = [
  "Delhi",
  "South Delhi",
  "West Delhi",
  "East Delhi",
  "Noida",
  "Greater Noida",
  "Noida Extension",
  "Ghaziabad",
  "Indirapuram",
  "Gurgaon",
  "Faridabad",
];

function NailartLocationSection() {
  return (
    <section className="nailart-location-section">
      <div className="nailart-location-container">

        <p className="nailart-location-eyebrow">Service Coverage</p>

        <h2 className="nailart-location-heading">
          Nail Extension Near You in <span>Delhi NCR</span>
        </h2>

        <p className="nailart-location-subtext">
          Book at-home service across major neighbourhoods. Availability may
          vary by pin code.
        </p>

        <div className="nailart-location-grid">
          {LOCATIONS.map((place) => (
            <span className="nailart-location-pill" key={place}>
              {place}
            </span>
          ))}
        </div>

        <p className="nailart-location-note">
          Looking for nail art near you? Book nail extensions at home in
          Delhi, gel or acrylic nail extensions in Noida, and a nail artist
          at home in Gurgaon. We also offer nail services at home in
          Ghaziabad, bridal nail art in Faridabad and nail extensions in
          Greater Noida. Share your pin code to confirm coverage.
        </p>

      </div>
    </section>
  )
}

export default NailartLocationSection


// export default NailartLocationSection